export default {
  offer_created: 'Offer successfully created',
  offer_cancelled: 'Offer successfully cancelled',
  failed_to_cancel: 'Failed to cancel offer',
  failed: 'Failed to create offer'
}



// WEBPACK FOOTER //
// ./src/js/i18n/to_replace/offers.js